import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Alex wird am 11. Mai 23 Jahre alt. Seine Freundin heißt Sophie. Er tanzt sehr gern, spielt gerne Nintendo und geht gerne mit seinen Freunden fort. Er mag es nicht, wenn Leute streiten oder gemein sind.'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'das-project-foto-alex2_jrhgv1',
    alt: 'dasProject Foto Alex',
    aspectRatio: 0.8
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'das-project-foto-alex3_juphiu',
    alt: 'dasProject Foto Alex',
    aspectRatio: 0.8
  },
  {
    type: 'text',
    text: 'Fragt man ihn ob er sich von anderen unterscheidet, sagt er dass er besser tanzt als manch anderer und sogar manchmal im Fernsehen ist. Seine Lebensweisheit: Ich mag gern alles. Das macht er am liebsten: Mit Freunden tanzen oder Spaß haben.'
  }
]

const color = 'blue'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Alex' next={1} previous={8}/>
      </div>
    )
  }
}

exports.data = {
  color: 'blue',
  number: 1
}



// WEBPACK FOOTER //
// ./alex.js